import React from "react";
import css from "../../style/visionStyle.module.css";
import ElevatorIcon from "../Icons/ElevatorIcon";
import StairsIcon from "../Icons/StairsIcon";
import MainFloorIcon from "../Icons/MainFloorIcon";
import ArrowTooltips from "../Booking/CustomTooltip";


const mediumTypes = [
  { key: "elevator", label: "Elevator", Icon: ElevatorIcon },
  { key: "stairs", label: "Stairs", Icon: StairsIcon },
  { key: "mainfloor", label: "Main floor", Icon: MainFloorIcon },
];

const BookingMedium = ({
  location,
  medium,
  clickFunction,
  label = "From",
}) => {
  if (!location) return <></>;



  return (
    <div className={`${css?.bookingMediumMd} mb-2 mt-2 font-instrument`}>
      <div className={css?.bookingMediumItemsMd}>
        {mediumTypes.map((item) => {
          const isActive = medium === item.key;
          const Icon = item.Icon;

          // Apply flip only if label is "From" and item is "Stair"
          const flipStyle =
            label === "To" && item.key === "stairs"
              ? { transform: "rotate(-90deg)" } // anti-clockwise tilt
              : {};

          return (
            <div
              key={item.key}
              className={`${css?.bookingMediumItem} flex flex-col items-center justify-center gap-1 cursor-pointer`}
              onClick={() => clickFunction(item.key)}
              style={{
                backgroundColor: isActive ? "var(--primary)" : "transparent",
                color: isActive ? "#fff" : "var(--primary)",
                borderColor: "var(--primary)",
              }}
            >
              <div
                className="w-7 h-7 flex items-center justify-center"
                style={flipStyle}
              >
                <Icon width={23} height={23} />
              </div>
              <div className="text-sm font-medium">{item.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BookingMedium;
